import axios from 'axios';
import application from '@/api/application';
import bid from '@/api/bid';
import company from '@/api/company';
import dispatchers from '@/api/dispatchers';
import settlements from '@/api/settlements';
import contract from '@/api/contract';
import load from '@/api/load';
import loadboard from '@/api/loadboard';
import map from '@/api/map';
import planner from '@/api/planner';
import user from '@/api/user';
import referral from '@/api/referral';
import firebase from 'firebase';
import store from '@/store';
import stripe from '@/api/stripe';
import quickBooks from '@/api/quickBooks';
import xero from '@/api/xero';
import siteDesignation from '@/api/siteDesignation';

const databaseUri = process.env.REACT_APP_FIREBASE_DB_URI || `https://${process.env.REACT_APP_FIRABASE_APP_NAME}.firebaseio.com`;
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_KEY,
  authDomain: `${process.env.REACT_APP_FIRABASE_APP_NAME}.firebaseapp.com`,
  databaseURL: databaseUri,
  storageBucket: `${process.env.REACT_APP_FIRABASE_APP_NAME}.appspot.com`,
};
firebase.initializeApp(firebaseConfig);

axios.defaults.baseURL = `${process.env.API_URL}/${process.env.API_VERSION}`;
axios.defaults.headers.common['Content-Type'] = 'application/json';
axios.defaults.headers.common.Accept = 'application/json';

axios.interceptors.request.use(async (config) => {
  if (firebase.auth().currentUser) {
    const token = await firebase.auth().currentUser.getIdToken(true);
    if (token) {
      // eslint-disable-next-line no-param-reassign
      config.headers.Authorization = `Bearer ${token}`;
    }
  }

  return config;
},
);

axios.interceptors.response.use(response => response, (error) => {
  if (error && error.response) {
    switch (error.response.status) {
      case /^5\d{2}/.test(error.response.status): {
        store.dispatch('applications/setErrorNotification', { message: 'Something went wrong on the server. Please try again later.' });
        return Promise.reject(error);
      }
      default: {
        return Promise.reject(error.response.data);
      }
    }
  } else {
    return Promise.reject(error);
  }
});

export default {
  application,
  bid,
  company,
  contract,
  load,
  loadboard,
  map,
  planner,
  referral,
  user,
  dispatchers,
  settlements,
  stripe,
  quickBooks,
  xero,
  siteDesignation,
};



// WEBPACK FOOTER //
// ./src/api/index.js